export default __webpack_public_path__ + "static/media/add-template-blue.25f89c3f.svg";